var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"divide-y divide-gray-200"},_vm._l((_vm.temporaryMediaUploads),function(temporaryMediaUpload){return _c('TemporaryMediaUploadListItem',{key:temporaryMediaUpload.id,attrs:{"temporary-upload":temporaryMediaUpload,"on-remove":_vm.onRemove}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }